module.exports = __webpack_public_path__ + "img/yonghu.83ee4e78.png";